var React = require('react');

function IconBox (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M851.748 460.429H148.887V309.395c0-33.712 27.427-61.139 61.139-61.139H790.61c33.712 0 61.139 27.427 61.139 61.139l-.001 151.034zm-650.861-52h598.861v-99.034c0-5.039-4.1-9.139-9.139-9.139H210.026c-5.039 0-9.139 4.1-9.139 9.139v99.034zM618.113 643.944h-235.59c-27.121 0-49.185-22.064-49.185-49.185v-45.58c0-27.12 22.064-49.185 49.185-49.185h235.59c27.12 0 49.185 22.064 49.185 49.185v45.58c-.001 27.12-22.065 49.185-49.185 49.185zm-232.775-52h229.959v-39.949H385.338v39.949z","key":0}),React.createElement("path",{"d":"M775.266 656.442v110.791a9.185 9.185 0 0 1-9.185 9.185H234.553a9.185 9.185 0 0 1-9.185-9.185V460.324h549.897v93.3c0 14.359 11.641 26 26 26s26-11.641 26-26v-145.3H173.369v358.909c0 33.791 27.393 61.185 61.185 61.185h531.529c33.791 0 61.184-27.393 61.184-61.184V656.442c0-14.359-11.641-26-26-26-14.361 0-26.001 11.641-26.001 26z","key":1})]);
}

IconBox.displayName = "IconBox";

IconBox.defaultProps = {"viewBox":"0 0 1000.636 1000.678"};

module.exports = IconBox;

IconBox.default = IconBox;
